import { queryOptions, useMutation, useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { getAllWellbeingAssignees, getAllWellbeingAssignments, getAllWellbeingReferrals, getAssignmentsForReferral, getWellbeingReferralDashboard, remindWellbeingReferralAssignment } from "./api";

export const allWellbeingAssignmentsQueryOptions = () =>
    queryOptions({
        queryKey: ["wellbeing", "assignments", "all"],
        queryFn: () => getAllWellbeingAssignments(),
        staleTime: 60_000,
    });

export function useAllWellbeingAssignments() {
    return useQuery(allWellbeingAssignmentsQueryOptions());
}

export function useAllWellbeingAssignmentsSuspense() {
    return useSuspenseQuery(allWellbeingAssignmentsQueryOptions());
}

export const wellbeingReferralDashboardQueryOptions = (from: string, to: string) =>
    queryOptions({
        queryKey: ["wellbeing", "dashboard", from, to],
        queryFn: () => getWellbeingReferralDashboard(from, to),
        staleTime: 60_000,
    });

export function useWellbeingReferralDashboard(from: string, to: string, enabled = true) {
    return useQuery({ ...wellbeingReferralDashboardQueryOptions(from, to), enabled });
}

export const allWellbeingReferralsQueryOptions = () =>
    queryOptions({
        queryKey: ["wellbeing", "referrals", "all"],
        queryFn: () => getAllWellbeingReferrals(),
        staleTime: 60_000,
    });

export function useAllWellbeingReferrals() {
    return useQuery(allWellbeingReferralsQueryOptions());
}

export function useAllWellbeingReferralsSuspense() {
    return useSuspenseQuery(allWellbeingReferralsQueryOptions());
}

export const wellbeingAssigneesQueryOptions = () =>
    queryOptions({
        queryKey: ["wellbeing", "assignees"],
        queryFn: () => getAllWellbeingAssignees(),
        staleTime: 60_000,
    });

export function useAllWellbeingAssignees() {
    return useQuery(wellbeingAssigneesQueryOptions());
}

export function useAllWellbeingAssigneesSuspense() {
    return useSuspenseQuery(wellbeingAssigneesQueryOptions());
}

type WellbeingAssignmentParams = {
    referralId: number;
}

export const wellbeingAssignmentsQueryOptions = (referralId: number) =>
    queryOptions({
        queryKey: ["wellbeing-referrals", "assignments", referralId],
        queryFn: () => getAssignmentsForReferral(referralId),
        staleTime: 60_000,
    });

export function useWellbeingAssignments(referralId: number, enabled = true) {
    return useQuery({ ...wellbeingAssignmentsQueryOptions(referralId), enabled });
}

export function useWellbeingAssignmentsSuspense(referralId: number) {
    return useSuspenseQuery(wellbeingAssignmentsQueryOptions(referralId));
}

export function useRemindWellbeingReferralAssignment() {
    return useMutation({
        mutationFn: (assignmentId: number) => remindWellbeingReferralAssignment(assignmentId),
    });
}
